import ReactDOM from "react-dom";
import React from "react";
import ImageComparator from "./components/ImageComparator.jsx";

export const addImageComparator = (element) => {
    if(! element)
    {
        return
    }

    const {
        imageLeftSrc,
        imageLeftAlt,
        imageRightSrc,
        imageRightAlt,
        caption
    } = element.dataset

    ReactDOM.render(
        <ImageComparator
            imageLeft={{
                src: imageLeftSrc,
                alt: imageLeftAlt,
            }}
            imageRight={{
                src: imageRightSrc,
                alt: imageRightAlt,
            }}
            caption={caption}
        />,
        element
    )
}
